import React from "react";

import styled from "styled-components";
import isNil from "lodash/isNil";
import get from "lodash/get";
import find from "lodash/find";

import PlaceIcon from "@mui/icons-material/Place";
import Badge from "@mui/material/Badge";
import HomeIcon from "@mui/icons-material/Home";
import HotelIcon from "@mui/icons-material/Hotel";

import { ESTATE_DISPLAY_STATUS } from "../../helpers/constants";

const EstateItemHeader = ({
  id,
  name,
  category,
  purposeStatus,
  displayStatusId,
  fullAddress,
  country,
  energyClass,
  onClickTitle,
  displayPurposeStatus,
  price,
  currency,
  room,
  isProject,
  isUnitView,
  actions,
  actionBtnAtTop,
}) => {
  const titleProps = {
    role: !isNil(onClickTitle) ? "button" : "heading",
    onClick: !isNil(onClickTitle) ? () => onClickTitle(id) : undefined,
  };

  const formatPrice = (price) =>
    new Intl.NumberFormat(undefined, {}).format(price);

  const displayPrice = !isNil(price) && !isNil(currency);

  const displayStatus = find(
    ESTATE_DISPLAY_STATUS,
    (status) => status.id === displayStatusId
  );

  return (
    <StyleWrapper className="estate-header d-flex justify-content-between">
      <div>
        <div className="d-flex status-container">
          {displayPurposeStatus && (
            <div className="purpose-status">
              <img src="/assets/icons/loading-purpose-status.svg" alt="" />
              <span>{purposeStatus}</span>
            </div>
          )}
          {displayStatus && isUnitView && (
            <div className="display-status">
              <Badge variant="dot" />
              <span>{get(displayStatus, ["name"])}</span>
            </div>
          )}
        </div>
        <div className="d-flex align-items-center name-container">
          <h4 className="name text-ellipsis" {...titleProps}>
            {name}
          </h4>
          {category && (
            <div className="category d-flex align-items-center">
              <HomeIcon htmlColor="var(--orange-light)" sx={{ height: 15 }} />
              <span>{category}</span>
            </div>
          )}
          {isProject && (
            <div className="project">
              <span>Projet</span>
            </div>
          )}
        </div>
        <div className="d-flex justify-content-between">
          <p className="location d-flex align-items-center">
            <span className="full-address">
              <PlaceIcon htmlColor="var(--blue)" sx={{ height: 18 }} />
              <span>{fullAddress}</span>
            </span>
            {country && <span>{country}</span>}
            <span>#{id}</span>
            {energyClass && <span>PEB {energyClass}</span>}
            {room && (
              <span className="d-flex align-items-center">
                <HotelIcon htmlColor="var(--blue-dark)" sx={{ height: 18 }} />
                <span>{room}</span>
              </span>
            )}
          </p>
        </div>
      </div>
      <div className="d-flex flex-column justify-content-between align-items-end price-container">
        {displayStatus && !isUnitView && (
          <div className="display-status">
            <Badge variant="dot" />
            <span>{get(displayStatus, ["name"])}</span>
          </div>
        )}
        {actionBtnAtTop && actions && actions}
        {displayPrice && (
          <p className="price">
            {formatPrice(price)} {currency}
          </p>
        )}
        {!actionBtnAtTop && actions && actions}
      </div>
    </StyleWrapper>
  );
};

const StyleWrapper = styled.div`
  position: relative;

  .price {
    color: var(--blue);
    font-weight: 700;
    font-size: 26px;
    margin: 0;
    align-self: end;
  }

  .status-container {
    gap: 5px;
  }

  .purpose-status,
  .project {
    display: flex;
    align-items: center;
    gap: 5px;
    color: var(--blue-dark);
    font-size: 10px;
    font-weight: 700;
    background-color: var(--menu-active-color);
    width: fit-content;
    border-radius: 3px;
    padding: 5px 10px;
    margin: 0;
    text-transform: capitalize;

    svg {
      font-size: 12px;
    }
  }

  .project {
    margin-left: 10px;
  }

  .name {
    font-size: 26px;
    font-weight: 700;
    color: var(--text-color);
    margin: 0;

    &[role="button"]:hover {
      text-decoration: underline;
    }
  }

  .location {
    text-transform: capitalize;
    font-size: 12px;
    color: var(--light-grey-text);
    margin: 0;

    & > span:not(:first-child) {
      margin-left: 10px;
    }

    & > span:not(:last-child) {
      padding-right: 10px;
      border-right: 1px solid var(--menu-active-color);
    }
  }

  .category {
    margin-left: 10px;
    font-size: 12px;
    color: var(--orange-light);
    text-transform: capitalize;
  }

  .display-status {
    font-size: 10px;
    background-color: var(--green-color);
    border-radius: 3px;
    padding: 5px 10px 5px 15px;

    span:first-child {
      background-color: var(--white);
    }

    & > span:last-child {
      color: var(--white);
      text-transform: capitalize;
      margin-left: 10px;
    }
  }
`;

export default EstateItemHeader;
